import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { AllocationStabilityPeriod } from 'components/reports/Metrics/constants/AllocationStability'
import { VehicleTypeFilter } from 'generated/graphql'

export interface AllocationStabilityFilterValues {
  period: AllocationStabilityPeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const ALLOCATION_STABILITY_DEFAULT_FILTERS: AllocationStabilityFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const AllocationStabilityFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<AllocationStabilityFilterValues>({
    defaultValues: ALLOCATION_STABILITY_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
